import { render, staticRenderFns } from "./room.vue?vue&type=template&id=121746ac&scoped=true"
import script from "./room.vue?vue&type=script&lang=js"
export * from "./room.vue?vue&type=script&lang=js"
import style0 from "./room.vue?vue&type=style&index=0&id=121746ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121746ac",
  null
  
)

export default component.exports